import { ApiResponse } from "@/utils/ApiResponse";
import { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import apiClient from "@/clients/apiClient";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";

export async function ListMarcaVehiculoAction(
  paginacionFilterParams: PaginacionFilterParams
): Promise<ApiResponse<MarcaVehiculoInterface>> {
  const { data } = await apiClient.get<MarcaVehiculoInterface>(
    "/gvMarcaVehiculos",
    {
      params: paginacionFilterParams,
    }
  );
  return {
    status: 200,
    data,
    message: "Marca de vehiculos obtenidas correctamente",
  };
}
